import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { isValidFunction, tr, useFormValues } from 'mmfintech-commons'

import { Link } from 'react-router-dom'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'

import type { CreditCardConfirmStepProps } from '../types'

export const CreditCardOtp = ({ onSubmit, onCancel }: CreditCardConfirmStepProps) => {
  const { checkoutPayError, checkoutPayFetching } = useSelector(
    ({ checkout: { checkoutPayError, checkoutPayFetching } }) => ({
      checkoutPayError,
      checkoutPayFetching
    }),
    shallowEqual
  )

  const formValues = useFormValues({
    otp: { required: true }
  })

  const handleSubmit = () => {
    if (formValues.areValid()) {
      onSubmit(formValues.prepare())
    }
  }

  useEffect(() => {
    return () => {
      formValues.reset()
    }
  }, [])

  return (
    <>
      <div className='payment-method-wrapper' data-test='credit-card-otp'>
        {tr('CHECKOUT.CREDIT_CARD.OTP.TITLE', 'Confirm payment')}
      </div>

      <Input
        type='text'
        data-test='otp-input'
        label={tr('CHECKOUT.CREDIT_CARD.OTP.OTP', 'Code')}
        {...formValues.registerInput('otp')}
        hideErrorLine
        autoComplete='off'
      />

      <ErrorDisplay error={checkoutPayError} />

      <div className='buttons'>
        <Button
          type='button'
          color='primary'
          text={tr('CHECKOUT.CREDIT_CARD.COMPLETE_BUTTON', 'Complete payment')}
          onClick={handleSubmit}
          loading={checkoutPayFetching}
          data-test='button-complete'
        />

        {isValidFunction(onCancel) ? (
          <div className='cancel-button-container mt-1'>
            <Link to='#' onClick={onCancel} data-test='cancel-button'>
              {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            </Link>
          </div>
        ) : null}
      </div>
    </>
  )
}
